export enum OrigemProtocoloEnum {
  SEI = 'SEI'
}
